import React, { useState, useEffect } from "react";
import Styles from "./style.module.css";
import { FiPlusSquare } from "react-icons/fi";
import { useNavigate } from "react-router";
import { GET_FBAR_details } from "Services/Requests";
import { showWarningAlert } from "Utils/Alerts";
import Load from "Components/Loader/loader";
import { useStore } from "Store";

function DependantInfo() {
    const navigate = useNavigate();
    const { isDisabled } = useStore((state: any) => state);

    const [loading, setLoading] = useState(true);
    const [DependantInfo, setDependantInfo] = useState([]);
    const GetDetails = async () => {
        setLoading(true);
        try {
            const response = await GET_FBAR_details();
            setTimeout(() => {
                setLoading(false);
            }, 300);
            if (response?.data.status === 1) {
                setDependantInfo(response.data?.fbar_details);
            }
        } catch (err: any) {
            console.log(err);
            showWarningAlert(
                "Something went wrong try again,if Issue persists Contact Support team"
            );
            setLoading(false);
        }
    };
    useEffect(() => {
        GetDetails();
    }, []);
    console.log(DependantInfo);
    return (
        <div className={Styles["Container"]}>
            {loading && <Load />}
            <div className={Styles["depedent-wrapper"]}>
                <header>
                    <h3>Fbar Info</h3>
                    {!isDisabled && (
                        <button
                            onClick={() =>
                                navigate("/auth/basic-info/fbar-info/add")
                            }>
                            <FiPlusSquare />
                            Add Fbar
                        </button>
                    )}
                </header>
                <div className={Styles["table-wrapper"]}>
                    <table className={Styles["tax-years"]}>
                        <thead className={Styles["tax-heading"]}>
                            <tr>
                                <th>Account Belongs</th>
                                <th>Bank Name</th>
                                <th>Type of Account</th>
                                <th>Account Maintenance Currency</th>
                                {/* <th>Visa Status</th> */}
                            </tr>
                        </thead>
                        <tbody>
                            {DependantInfo.length > 0 ? (
                                DependantInfo.map((item: any) => (
                                    <tr
                                        onClick={() =>
                                            navigate(
                                                `/auth/basic-info/fbar-info/add?id=${item?.id}`
                                            )
                                        }>
                                        <td>{item?.acc_belongs_to}</td>
                                        <td>{item?.bank_name} </td>
                                        <td>{item?.type_of_account}</td>
                                        <td>
                                            {item?.account_maintenance_currency}
                                        </td>
                                        {/* <td>{item?.visa_status}</td> */}
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan={5}> No Record Found</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
}

export default DependantInfo;
